import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
const reportNotesApi = buildService('/claim_project_reports/{id}/report_notes', {
  only: ['all', 'create', 'update', 'delete']
});
const reportNotesService = {
  useFetchAll: (setLoading, reportId) => {
    const [notes, setNotes, fetchNotes] = serviceMethods.useFetch({
      callback: useCallback(async () => {
        if (!reportId) return [];
        const response = await reportNotesApi.all(reportId);
        return Array.isArray(response) ? response : [];
      }, [reportId]),
      setLoading,
      initialStateValue: []
    });
    return [notes, setNotes, fetchNotes];
  },
  useCreate: (setLoading, setNotes, notes, reportId) => {
    const createNote = serviceMethods.useCreate({
      callback: useCallback(async data => {
        if (!reportId) return;
        const response = await reportNotesApi.create(reportId, {
          report_note: data
        });
        setNotes([response, ...notes]);
        return response;
      }, [notes, setNotes, reportId]),
      setLoading
    });
    return [createNote];
  },
  useUpdate: (setLoading, setNotes, notes, reportId) => {
    const updateNote = serviceMethods.useUpdate({
      callback: useCallback(async _ref => {
        let {
          id,
          data
        } = _ref;
        if (!reportId) return;
        const response = await reportNotesApi.update(reportId, id, {
          report_note: data
        });
        setNotes(notes.map(n => n.id === id ? response : n));
        return response;
      }, [notes, setNotes, reportId]),
      setLoading
    });
    return [updateNote];
  },
  useDelete: (setLoading, setNotes, notes, reportId) => {
    const deleteNote = serviceMethods.useDelete({
      callback: useCallback(async noteId => {
        if (!reportId) return;
        await reportNotesApi.delete(reportId, noteId);
        setNotes(notes.filter(n => n.id !== Number(noteId)));
      }, [notes, setNotes, reportId]),
      setLoading
    });
    return [deleteNote];
  }
};
reportNotesService.useCrud = (setLoading, reportId) => {
  const [notes, setNotes, fetchNotes] = reportNotesService.useFetchAll(setLoading, reportId);
  const [createNote] = reportNotesService.useCreate(setLoading, setNotes, notes, reportId);
  const [updateNote] = reportNotesService.useUpdate(setLoading, setNotes, notes, reportId);
  const [deleteNote] = reportNotesService.useDelete(setLoading, setNotes, notes, reportId);
  return {
    notes,
    setNotes,
    fetchNotes,
    createNote,
    updateNote,
    deleteNote
  };
};
export default reportNotesService;